import { gql } from 'graphql-request';

import { KARAOKE_TEXT_BRANDING_QUERY } from './branding-gql';
import { COMPOSITION_TEMPLATE_QUERY_FRAGMENT } from './compositions-gql';

import type { RequestDocument } from 'graphql-request';

export const VIDEO_TEMPLATE_CARD_FRAGMENT = `{
  compositionTemplate ${COMPOSITION_TEMPLATE_QUERY_FRAGMENT}
  enabled
  lockPosition
}`;

/**
 * PLAT-11034 — the hook slot. `placementOverride` is the nametag's mechanism
 * (a positionable overlay carries where it sits); `duration` governs a
 * `clip-start` hook only.
 */
export const VIDEO_TEMPLATE_HOOK_FRAGMENT = `{
  compositionTemplate ${COMPOSITION_TEMPLATE_QUERY_FRAGMENT}
  placementOverride
  duration
  enabled
  lockPosition
}`;

export const VIDEO_TEMPLATE_NAMECARD_FRAGMENT = `{
  compositionTemplate ${COMPOSITION_TEMPLATE_QUERY_FRAGMENT}
  placementOverride
  enabled
  lockPosition
}`;

export const VIDEO_TEMPLATE_CAPTIONS_FRAGMENT = `{
  captionsConfig ${KARAOKE_TEXT_BRANDING_QUERY}
  enabled
  lockPosition
  verticalPosition
  horizontalPosition
  horizontalAlignment
  fontSize
}`;

export const VIDEO_TEMPLATE_LOGO_CONFIGURATION_FRAGMENT = `{
  logo {
    id
    url
  }
  enabled
  lockPosition
  opacity
  placementX
  placementY
  width
  height
  fit
}`;

export const VIDEO_TEMPLATE_CONFIG_QUERY_FRAGMENT = `{
  logoConfiguration ${VIDEO_TEMPLATE_LOGO_CONFIGURATION_FRAGMENT}
  introCardConfiguration ${VIDEO_TEMPLATE_CARD_FRAGMENT}
  endCardConfiguration ${VIDEO_TEMPLATE_CARD_FRAGMENT}
  captionsConfiguration ${VIDEO_TEMPLATE_CAPTIONS_FRAGMENT}
  namecardConfiguration ${VIDEO_TEMPLATE_NAMECARD_FRAGMENT}
  hookConfiguration ${VIDEO_TEMPLATE_HOOK_FRAGMENT}
}`;

export const VIDEO_TEMPLATE_QUERY_FRAGMENT = `{
  id
  label
  internalName
  commonConfiguration ${VIDEO_TEMPLATE_CONFIG_QUERY_FRAGMENT}
  override16x9 ${VIDEO_TEMPLATE_CONFIG_QUERY_FRAGMENT}
  override9x16 ${VIDEO_TEMPLATE_CONFIG_QUERY_FRAGMENT}
  override1x1 ${VIDEO_TEMPLATE_CONFIG_QUERY_FRAGMENT}
  isGlobalPreset
}
`;

export const VIDEO_TEMPLATES_QUERY: RequestDocument = gql`
  query VideoTemplatesAll($ids: [ItemId!], $first: IntType, $skip: IntType) {
    allVideoTemplates(
      first: $first,
      skip: $skip,
      filter: {
        isDeleted: { eq: false },
        OR: [
          { isGlobalPreset: { eq: true } },
          { id: { in: $ids } }
        ]
      }
    ) 
      ${VIDEO_TEMPLATE_QUERY_FRAGMENT}
  }`;

// Minimal query to find a single global preset ID (used only for block model
// discovery when creating the first template for an opted-out customer).
export const VIDEO_TEMPLATE_GLOBAL_PRESET_ID_QUERY: RequestDocument = gql`
  query VideoTemplateGlobalPresetId {
    allVideoTemplates(
      first: 1
      filter: { isDeleted: { eq: false }, isGlobalPreset: { eq: true } }
    ) {
      id
    }
  }
`;

// Query that excludes global presets — only returns templates matching the
// provided IDs that are not global presets. Used when the customer type opts
// out of global templates.
export const VIDEO_TEMPLATES_WITHOUT_GLOBAL_QUERY: RequestDocument = gql`
  query VideoTemplatesWithoutGlobal($ids: [ItemId!], $first: IntType, $skip: IntType) {
    allVideoTemplates(
      first: $first,
      skip: $skip,
      filter: {
        isDeleted: { eq: false },
        isGlobalPreset: { eq: false },
        id: { in: $ids }
      }
    ) 
      ${VIDEO_TEMPLATE_QUERY_FRAGMENT}
  }`;
